const PermissionActions = {
  SET_PERMISSIONS: "SET_PERMISSIONS",
  GET_PERMISSIONS: "GET_PERMISSIONS",
  SET_SUB_ADMIN_PERMISSION: "SET_SUB_ADMIN_PERMISSION",
  GET_SUB_ADMIN_PERMISSION: "GET_SUB_ADMIN_PERMISSION",
};

export default PermissionActions;
